import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import webDevPackages from '../data/webDevPackages';
import './UpdatedPricing.scss';
import { usePageTitle } from '../context/PageTitleContext';

function PackageCard({ packageItem, onSelect, isProcessing }) {
  const [quantity, setQuantity] = useState(1);

  const handleQuantityChange = (e) => {
    setQuantity(Math.max(1, parseInt(e.target.value) || 1));
  };

  const totalPrice = packageItem.basePrice * quantity;

  const handlePurchaseClick = () => {
    if (isProcessing) return;
    onSelect(packageItem, quantity, totalPrice);
  };

  return (
    <div className={`package-card ${packageItem.isPopular ? "popular" : ""}`}>
      {packageItem.isPopular && <div className="popular-badge">Popular</div>}
      <h3>{packageItem.title}</h3>
      <div className="price">${packageItem.basePrice}</div>
      <p className="description">{packageItem.description}</p>

      <ul className="features">
        {packageItem.features.map((feature, index) => (
          <li key={index}>{feature}</li>
        ))}
      </ul>

      {!packageItem.isFixedPackage && (
        <div className="quantity-selector">
          <label>
            Quantity:
            <input
              type="number"
              min="1"
              value={quantity}
              onChange={handleQuantityChange}
              disabled={isProcessing}
            />
          </label>
          <div className="quantity-logic">{packageItem.quantityLogic}</div>
        </div>
      )}

      <div className="total-price">Total: ${totalPrice}</div>

      <button
        className="btn btn-primary purchase-btn"
        onClick={handlePurchaseClick}
        disabled={isProcessing}
      >
        {isProcessing ? "Processing..." : "Buy Now"}
      </button>
    </div>
  );
}

function UpdatedPricing() {
  const [processingPackageId, setProcessingPackageId] = useState(null);
  const navigate = useNavigate();
  const { setPageTitle } = usePageTitle();
  
  // Set page title when component mounts
  useEffect(() => {
    setPageTitle("Website Services Pricing");
  }, [setPageTitle]);

  const handlePackageSelect = (packageItem, quantity, totalPrice) => {
    setProcessingPackageId(packageItem.id);
    
    // Navigate to guest checkout with package details
    navigate(`/guest-checkout?packageId=${packageItem.id}&quantity=${quantity}`);
  };

  return (
    <div className="updated-pricing-page">
      <div className="pricing-container">
        <div className="pricing-header">
          <h1>Professional Web Development Services</h1>
          <p>Choose the perfect package for your business needs. No login required - just provide your details at checkout.</p>
        </div>

        <div className="packages-grid">
          {webDevPackages.map((packageItem) => (
            <PackageCard
              key={packageItem.id}
              packageItem={packageItem}
              onSelect={handlePackageSelect}
              isProcessing={processingPackageId === packageItem.id}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export default UpdatedPricing; 